import shallow from 'zustand/shallow';

// IDs and classes
import {
  cl_sidebar,
  cl_sidebarActions,
  cl_sidebarIcon,
  // cl_sidebarContent,
  cl_sidebarSeparator,
  cl_sidebarDefaultActions,
  cl_sidebarBottom,
  cl_sidebarTop,
} from '../constants/html-classnames';

// Components
// import { StdContentViewer } from './std-content-viewer';

// Functions
import {
  isActiveOnTrue,
  isClosedOnFalse,
  isInactiveOnTrue,
} from '../utils/css-helpers';
import { ContactId, DocsId /* , UspId */ } from '../constants/infobox-ids';
import {
  CameraBttn,
  ContactBttn,
  DocsBttn,
  GovieMenuBttn,
  GovieModeBttn,
  HelpBttn,
  HotspotBttn,
  InfoboxBttn,
  LangBttn,
  PowerBttn,
  SettingsBttn,
  // UspBttn,
} from './std-sidebar-buttons';
import { useStore, staticSettings } from '../../state/ui-store';

// Import custom style always at last!
import './std-sidebar.css';

const selector = ({
  activeLanguage,
  helpBttnActive,
  settingsBttnActive,
  infoBttnActive,
  langBttnActive,
  moreBttnActive,
  powerBttnActive,
  hotspotBttnActive,
  cameraBttnActive,
  govieModeBttnActive,
  playbarBttnActive,
  pageId,
}: State) => ({
  activeLanguage,
  helpBttnActive,
  settingsBttnActive,
  infoBttnActive,
  langBttnActive,
  moreBttnActive,
  powerBttnActive,
  hotspotBttnActive,
  cameraBttnActive,
  govieModeBttnActive,
  playbarBttnActive,
  pageId,
});

const {
  sidebar: {
    renderBttnsTop,
    renderBttnsCenter,
    renderBttnsBottom,
    // renderUspBttn,
    renderContactBttn,
    renderDocsBttn,
    renderPowerBttn,
    renderHotspotBttn,
    renderGovieBttn,
    renderCameraBttn,
  },
} = staticSettings;

export const StdSidebar = () => {
  const {
    activeLanguage: { /* iso, */ dict },
    helpBttnActive,
    settingsBttnActive,
    infoBttnActive,
    langBttnActive,
    moreBttnActive,
    powerBttnActive,
    hotspotBttnActive,
    cameraBttnActive,
    govieModeBttnActive,
    playbarBttnActive,
    pageId,
  } = useStore(selector, shallow);

  const clMenuState = isInactiveOnTrue(
    settingsBttnActive || helpBttnActive || langBttnActive
  );
  const clSidebarState = `${cl_sidebar}
    ${isClosedOnFalse(infoBttnActive)}`;
  const clSidebarDefaultActionsState = `${cl_sidebarActions} ${isClosedOnFalse(
    moreBttnActive
  )}`;
  const clPageIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    infoBttnActive
  )} ${clMenuState}`;
  const clSettingsIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    settingsBttnActive
  )}`;
  const clHelpIconState = `${cl_sidebarIcon} ${isActiveOnTrue(helpBttnActive)}`;
  const cllangIconState = `${cl_sidebarIcon} ${isActiveOnTrue(langBttnActive)}`;
  /* const clUspIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    pageId === UspId
  )} ${clMenuState}`; */
  const clContactIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    pageId === ContactId
  )} ${clMenuState}`;
  const clDocsIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    pageId === DocsId
  )} ${clMenuState}`;
  const clPowerIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    powerBttnActive
  )} ${clMenuState}`;
  const clHotspotIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    hotspotBttnActive
  )} ${clMenuState}`;
  const clGovieModeIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    govieModeBttnActive
  )} ${clMenuState}`;
  const clCameraIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    cameraBttnActive
  )} ${clMenuState}`;
  const clPlaybarIconState = `${cl_sidebarIcon} ${isActiveOnTrue(
    playbarBttnActive
  )} ${clMenuState}`;
  const clBottomGroup = `${cl_sidebarDefaultActions} ${cl_sidebarBottom}`;

  return (
    <div className={clSidebarState}>
      <div className={cl_sidebarTop}>
        <div className={clSidebarDefaultActionsState}>
          {renderBttnsTop && (
            <div className={cl_sidebarDefaultActions}>
              <InfoboxBttn
                clIconState={clPageIconState}
                isActive={infoBttnActive}
              />
              <SettingsBttn clIconState={clSettingsIconState} />
              <HelpBttn clIconState={clHelpIconState} />
              <LangBttn clIconState={cllangIconState} />
              {/* <div className={cl_sidebarSeparator} /> */}
            </div>
          )}
          {renderBttnsCenter && (
            <div className={clSidebarDefaultActionsState}>
              {/* renderUspBttn && (
                <UspBttn clIconState={clUspIconState} dict={dict} />
              ) */}
              {renderContactBttn && (
                <ContactBttn clIconState={clContactIconState} dict={dict} />
              )}
              {renderDocsBttn && <DocsBttn clIconState={clDocsIconState} />}
              <div className={cl_sidebarSeparator} />
              {renderPowerBttn && <PowerBttn clIconState={clPowerIconState} />}
              {renderHotspotBttn && (
                <HotspotBttn clIconState={clHotspotIconState} />
              )}
              {renderGovieBttn && (
                <GovieModeBttn clIconState={clGovieModeIconState} />
              )}
              {renderCameraBttn && (
                <CameraBttn clIconState={clCameraIconState} />
              )}
            </div>
          )}
        </div>
      </div>
      {renderBttnsBottom && (
        <div className={clBottomGroup}>
          <div className={cl_sidebarSeparator} />
          <GovieMenuBttn clIconState={clPlaybarIconState} />
        </div>
      )}
    </div>
  );
};
